<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-video</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.video') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 10px 0 10px;"/>
      <template>        
        <v-btn-toggle
          v-model="content.TypeVideo"
          @change="handleChangeIsModified"
        >
          <v-btn :value="'youtube'" @click="content.TypeVideo = 'youtube'" text :disabled="!content.IsNew">
            <v-icon>mdi-youtube</v-icon>
          </v-btn>
          <v-btn :value="'vimeo'" @click="content.TypeVideo = 'vimeo'" text :disabled="!content.IsNew">
            <v-icon>mdi-vimeo</v-icon>
          </v-btn>
          <v-btn :value="'file'" @click="content.TypeVideo = 'file'" text :disabled="!content.IsNew">
            <v-icon>mdi-paperclip</v-icon>
          </v-btn>
        </v-btn-toggle>
      </template>
    </v-toolbar>
    <div
      v-show="!collapseContent"
      style="padding: 0 10px 10px 10px;"
    >
      <v-file-input
        v-if="content.TypeVideo === 'file' && !content.VideoURL && content.IsNew"
        v-model="file"
        display-size
        label="File input"
        @change="handleChangeFile"
      />
      <v-text-field
        v-else
        v-model="content.VideoURL"
        :label="$t('common.url')"
        hideDetails
        :disabled="content.TypeVideo === 'file'"
        @input="handleChangeIsModified"
      />
    </div>
  </div>
</template>
<script>
  import {
    mapState
  } from 'vuex'
  import api from '@/services/api'
  export default {
    props: {
      content: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      file: null,
      loading: false
    }),
    computed: {
      ...mapState('app',['collapseContent']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      }
    },
    mounted () {
      this.file = this.content.VideoURL
    },
    methods: {
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      },
      uploadVideo (file) {
        const body = {
          newVideo: file,
          EnterpriseID: this.enterpriseID
        }
        api.addItem('utils/video', body)
          .then(response => {
            if (response.status === 200) {
              this.handleChangeIsModified()
              this.file = response.data
              this.content.VideoURL = response.data
              this.loading = false
            }
          })
          .catch(error => {
            console.log('error', error)
            this.loading = false
          })
      },
      handleChangeFile () {
        const that = this
        this.loading = true
        const reader = new FileReader()
        reader.readAsDataURL(this.file)
        reader.onload = function () {
          that.uploadVideo(reader.result)
        }
        reader.onerror = function (error) {
          console.log('Error: ', error)
          this.loading = false
        }
      }
    }
  }
</script>

<style scoped>
</style>

